<template>
  <div class="footer">
    <p>&copy; RadixGeo 2019</p>
    <!-- <p>Icons made by <a href="https://www.flaticon.com/authors/Freepik">Freepik</a> from <a href="https://www.flaticon.com">www.flaticon.com</a></p> -->
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  display: flex;
  background-color: #052d3b;
  color: white;
  font-size: 0.7rem;
}

p {
  margin-bottom: 0;
  padding-left: 0.3rem;
}

a {
  color: white;
  text-decoration: none;
}
</style>